import { render, staticRenderFns } from "./ReservationWidget.vue?vue&type=template&id=c97e7a5a&scoped=true&"
import script from "./ReservationWidget.vue?vue&type=script&lang=js&"
export * from "./ReservationWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReservationWidget.vue?vue&type=style&index=0&id=c97e7a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97e7a5a",
  null
  
)

export default component.exports